import React, {useEffect, useState} from "react";


const RoutingInstructionRouteOrder = (props) => {

    const {
        elemId,
        itemsRouteOrder,
        setItemsRouteOrder,
        indexItem
    } = props;

    const [instructionRouteOrder, setInstructionRouteOrder] = useState('');

    useEffect(() => {
        let isMounted = true;

            const filteredNumberOrders = itemsRouteOrder?.find((value) => value?.id === elemId);
            const filteredGoods = filteredNumberOrders?.goods?.find((value, index) => index === indexItem);
            const changedGoodsItem = {...filteredGoods, importVGTD: instructionRouteOrder};
            const updatedGoods = filteredNumberOrders?.goods?.map((el, index) => index === indexItem ? changedGoodsItem : el);
            const changedOrder = {...filteredNumberOrders, goods: updatedGoods};
            const updatedRouteOrder = itemsRouteOrder?.map((el) => el.id === elemId ? changedOrder : el);
        isMounted && setItemsRouteOrder(updatedRouteOrder)

        return () => {
            isMounted = false;
        }
    },[instructionRouteOrder])

    return (
        <div>
            <input
                className="create-doc-set-loading-order-modal__table-row-input"
                type={'text'}
                value={instructionRouteOrder}
                onChange={(e) => setInstructionRouteOrder(e.currentTarget.value)}
            />
        </div>
    )
}
export default RoutingInstructionRouteOrder;